import { type AxiosError } from 'axios'
import { type Key } from 'swr'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  type SuccessfulUploadCustomerFileResponseDtoV1,
  UploadControllerV1ApiFactory,
  type UploadControllerV1ApiFileUploadV1TenantPostRequest,
} from '@redteclab/api/clients/composition-service-transactions'

import { useGlooApi } from '../../api'
import { useGlobalConfigContext } from '../../global-config'

type FetcherResponse = {
  data: SuccessfulUploadCustomerFileResponseDtoV1
  payLoad: UploadControllerV1ApiFileUploadV1TenantPostRequest
}

export type AfterSalesApiSwrUploadImageResponse = SWRMutationResponse<
  FetcherResponse,
  AxiosError,
  Key,
  UploadControllerV1ApiFileUploadV1TenantPostRequest
>

const getAfterSalesSwrUploadImageMutationKey = (): Key =>
  `useAfterSalesApiSwrUploadImage`
export const useAfterSalesApiSwrUploadImage =
  (): AfterSalesApiSwrUploadImageResponse => {
    const client = useGlooApi(UploadControllerV1ApiFactory)
    const globalConfig = useGlobalConfigContext()

    const fetcher = async (
      key: string,
      data: {
        arg: UploadControllerV1ApiFileUploadV1TenantPostRequest
      },
    ): Promise<FetcherResponse> => {
      const response = await client.fileUploadV1TenantPost({
        feature: data.arg.feature,
        file: data.arg.file,
        tenant: globalConfig.tenantAndEnv,
      })

      return { data: response.data, payLoad: data.arg }
    }

    return useSWRMutation(getAfterSalesSwrUploadImageMutationKey(), fetcher, {})
  }
